export default __webpack_public_path__ + "static/media/icon_character.4c364afa.jpg";